import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SystemNotificationsService} from "./system-notifications.service";


@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [
        SystemNotificationsService,
    ]
})
export class SystemNotificationsModule {
}
